export function getUrlParameter(name) {
  name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]')
  const regex = new RegExp('[\\?&]' + name + '=([^&#]*)')
  const results = regex.exec(location.search)

  return results === null ? undefined : decodeURIComponent(results[1].replace(/\+/g, ' '))
}

export function parsePhoneNumber(number) {
  if (number) {
    return number
      .replace(/-|,/g, '')
      .replace(/x\.?/g, ',,')
      .replace(/\s/g, '')
  }
}

export const trackGoogleAnalytics = (event) => {
  if (window.dataLayer) {
    dataLayer.push(event)
  }
}
